import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const HOMEHEROSHOWCASEBLOCK_LEGACY_FIELD_ORDER = [
  "background_image",
  "title",
  "link_url",
  "link_label",
  "button-size-y"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  homeHeroShowcaseBlockDescriptor: _generatedHomeHeroShowcaseBlockDescriptor,
  homeHeroShowcaseBlockBlocDefinition,
  homeHeroShowcaseBlockDashboardLayout,
  homeHeroShowcaseBlockConfig,
  homeHeroShowcaseBlockResolveConfig,
  homeHeroShowcaseBlockProperties,
} = doodBlockConfig(
  {
    name: "Header Hero Showcase",
    componentType: 'HomeHeroShowcaseBlockComponent',
    category: 'content',
    description: "Header Hero Showcase.",
    keywords: [],
    hideFromPicker: true,
    sharedFields: {}
  },

  () => ({
    background_image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.home-hero-showcase.background-image.label",
        help: "pages.blocks.home-hero-showcase.background-image.help",
      }
    }),
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.home-hero-showcase.title.label",
      }
    }),
    link_url: propertyValue({
      type: 'link',
      value: '',
      options: {
        label: "pages.blocks.home-hero-showcase.link-url.label",
      }
    }),
    link_label: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.home-hero-showcase.link-label.label",
      }
    }),
    "button-size-y": propertyValue({
      type: 'select',
      value: "M",
      options: {
        label: "pages.blocks.home-hero-showcase.button-size-y.label",
        multiple: false,
        choices: [
          {
            value: "S",
            label: "pages.blocks.home-hero-showcase.button-size-y.options.s",
          },
          {
            value: "M",
            label: "pages.blocks.home-hero-showcase.button-size-y.options.m",
          },
          {
            value: "L",
            label: "pages.blocks.home-hero-showcase.button-size-y.options.l",
          }
        ]
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'pages.blocks.home-hero-showcase.tab.content.label',
        fieldsets: [
          {
            legend: 'pages.blocks.home-hero-showcase.fieldset.image.label',
            fields: ["background_image"],
          },
          {
            legend: 'pages.blocks.home-hero-showcase.fieldset.title.label',
            fields: ["title"],
          },
          {
            legend: 'pages.blocks.home-hero-showcase.fieldset.button.label',
            fields: ["link_label", "link_url", "button-size-y"],
          },
        ],
      },
    ],
  })
);

export function homeHeroShowcaseBlockDescriptor(): IBlockDescriptor;
export function homeHeroShowcaseBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function homeHeroShowcaseBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedHomeHeroShowcaseBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedHomeHeroShowcaseBlockDescriptor, homeHeroShowcaseBlockProperties, fieldOrder);
}

export {
  homeHeroShowcaseBlockBlocDefinition,
  homeHeroShowcaseBlockDashboardLayout,
  homeHeroShowcaseBlockProperties,
  homeHeroShowcaseBlockConfig,
  homeHeroShowcaseBlockResolveConfig,
};

export type HomeHeroShowcaseBlockConfig = typeof homeHeroShowcaseBlockConfig;
